import { render } from "./QnaResult.vue?vue&type=template&id=44a36650"
import script from "./QnaResult.vue?vue&type=script&lang=js"
export * from "./QnaResult.vue?vue&type=script&lang=js"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__